export function isPackagePhotoSrc(v) {
  return typeof v === 'string' && /^data:image\//i.test(v.trim());
}
